import $ from 'jquery'

export default () => {
  let currentTab = 0;

  function stepNumber(n) {
    const step = document.getElementsByClassName('step');
    
    const stepNumper =  step[n].dataset.step;
    const stepPercent =  step[n].dataset.percent;
    const stepTitle =  step[n].dataset.title;

    const currentCount = document.querySelector('.step-form__count-current')
    const currentPercent = document.querySelector('.step-form__count-percent')
    const currentTitle = document.querySelector('.step-form__form-title > small')
    const currentTitleCount = document.querySelector('.step-form__form-title > span')
    const progressLine = document.querySelector('.step-form__progress__line')
    

    currentCount.innerHTML = stepNumper;
    currentPercent.innerHTML = stepPercent;
    currentTitle.innerHTML = stepTitle;
    currentTitleCount.innerHTML = stepNumper;

    progressLine.style.width = stepPercent
  }

  function showTab(n) {
    const nextButton = document.getElementById('nextBtn');
    const submitText = nextButton.dataset.submit;
    const nextStepText = nextButton.dataset.next;

    const step = document.getElementsByClassName('step');
    step[n].style.display = 'block';
    step[n].classList.add('active');
    
    if (n === (step.length - 1)) {
      $('#nextBtn > span').html(submitText);
      document.getElementById('nextBtn').classList.add('form-ready');
    } else {
      $('#nextBtn > span').html(nextStepText);
      document.getElementById('nextBtn').classList.remove('form-ready');
    }
    stepNumber(n)
  }

  showTab(currentTab);

  function validateForm() {
    let valid = true;
    const step = document.getElementsByClassName('step');
    const currentStepFilds = step[currentTab].getElementsByClassName('required');

  
    for (let i = 0; i < currentStepFilds.length; i+= 1) {
      console.log('tag', currentStepFilds[i].tagName)
      if (
        (currentStepFilds[i].tagName.toLowerCase() === 'select' && currentStepFilds[i].value === '' )
        || (currentStepFilds[i].tagName.toLowerCase() === 'input' && currentStepFilds[i].value === '' )
        ) {
        currentStepFilds[i].classList.add('error');
        valid = false;
      } else {
        currentStepFilds[i].classList.remove('error')
      }
    }

    
    console.log('lllkk')
    return valid;
  }

  function nextPrev(n) {
    const step = document.getElementsByClassName('step');
    if (n === 1 && !validateForm()) {
      return false;
    }
    if (currentTab + 1 < step.length || n === -1) {
      step[currentTab].style.display = 'none';
      step[currentTab].classList.remove('active');
      currentTab += n;
      return showTab(currentTab);
    }
  }


  $('#nextBtn').on('click', () => {
    nextPrev(1);
  })

}



// WEBPACK FOOTER //
// app/scripts/components/step-form.js